import { SVGProps } from 'react'

export const RecordVideoCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="44"
    height="44"
    viewBox="0 0 44 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g filter="url(#filter0_d_19145_39462)">
      <rect x="2" y="1" width="40" height="40" rx="20" fill="white" />
      <rect x="2.5" y="1.5" width="39" height="39" rx="19.5" stroke="#EAECF0" />
      <rect width="20" height="20" transform="translate(12 11)" fill="white" />
      <path
        d="M30.3337 18.4428C30.3337 17.9379 30.3337 17.6855 30.2338 17.5686C30.1472 17.4672 30.0173 17.4134 29.8843 17.4238C29.7311 17.4359 29.5526 17.6144 29.1956 17.9714L26.167 21L29.1956 24.0286C29.5526 24.3855 29.7311 24.564 29.8843 24.5761C30.0173 24.5866 30.1472 24.5327 30.2338 24.4313C30.3337 24.3144 30.3337 24.062 30.3337 23.5572V18.4428Z"
        stroke="#475467"
        stroke-width="1.66667"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.667 19.1666C13.667 17.7665 13.667 17.0664 13.9395 16.5316C14.1792 16.0612 14.5616 15.6788 15.032 15.4391C15.5668 15.1666 16.2669 15.1666 17.667 15.1666H22.167C23.5671 15.1666 24.2672 15.1666 24.802 15.4391C25.2724 15.6788 25.6548 16.0612 25.8945 16.5316C26.167 17.0664 26.167 17.7665 26.167 19.1666V22.8333C26.167 24.2334 26.167 24.9335 25.8945 25.4683C25.6548 25.9387 25.2724 26.3211 24.802 26.5608C24.2672 26.8333 23.5671 26.8333 22.167 26.8333H17.667C16.2669 26.8333 15.5668 26.8333 15.032 26.5608C14.5616 26.3211 14.1792 25.9387 13.9395 25.4683C13.667 24.9335 13.667 24.2334 13.667 22.8333V19.1666Z"
        stroke="#475467"
        stroke-width="1.66667"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_19145_39462"
        x="0"
        y="0"
        width="44"
        height="44"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_19145_39462"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_19145_39462"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
)
